<template>
  <v-container>
    <v-toolbar dense>
      <!--  <v-toolbar-title>{{ $t('account.title') }}</v-toolbar-title>
      <v-label>{{ $t('account.id')  }}</v-label>
      <v-label>{{ $t('account.email') }}</v-label>
      <v-btn>{{ $t('account.mail-btn')  }}</v-btn>
      <v-btn>{{ $t('account.pwd-btn')  }}</v-btn>
      <v-label>{{ $t('account.language.title')  }}</v-label>-->
    </v-toolbar>
  </v-container>
</template>

<script>
export default {
  mounted () {
  }
}
</script>

<style scoped>
</style>
